var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-structural-element-discussion",
    },
    [
      _c(
        "courseware-collapsible-box",
        {
          attrs: {
            title: _vm.text.comments,
            open: _vm.hasComments,
          },
        },
        [
          _c("courseware-structural-element-comments", {
            attrs: {
              structuralElement: _vm.structuralElement,
            },
            on: {
              hasComments: function hasComments($event) {
                _vm.hasComments = true
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.canEdit || _vm.userIsTeacher
        ? _c(
            "courseware-collapsible-box",
            {
              attrs: {
                title: _vm.text.feedback,
                open: _vm.hasFeedback,
              },
            },
            [
              _c("courseware-structural-element-feedback", {
                attrs: {
                  structuralElement: _vm.structuralElement,
                  canEdit: _vm.canEdit,
                },
                on: {
                  hasFeedback: function hasFeedback($event) {
                    _vm.hasFeedback = true
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }